import Request from '../utils/request'
// api 地址
const apiMall = 'https://roblex.zhimifan.com'

// 发送验证码
const getProducts = (params) => Request(params, apiMall + '/api/v1/expericesnses/edition/front', 'get')
const getProductsByDev = (params) => Request(params, apiMall + '/api/v1/expericesnses/ofdeveloper/show', 'get')
const getDevelopers = (params) => Request(params, apiMall + '/api/v1/Developer/front', 'get')
const getDevelopersDetails = (params) => Request(params, apiMall + '/api/v1/Developer/details', 'get')
const getProductDetails = (params) => Request(params, apiMall + '/api/v1/expericesnses/details', 'get')
const getBanner = (params) => Request(params, apiMall + '/api/v1/banner/front', 'get')
const getRandom = (params) => Request(params, apiMall + '/api/v1/expericesnses/random', 'get')

export default {
  getProducts,
  getDevelopers,
  getProductsByDev,
  getProductDetails,
  getDevelopersDetails,
  getBanner,
  getRandom
}
